export * from './delete-zeit-art.service';
export * from './delete-zeit-art.service.module';